import { removeParamsFromQuery, toParams } from '@marketplace-web/shared/utils'
import { ProductItemModel } from '@marketplace-web/item-box/product-item-data'

const BUNDLE_TRACKING_ID_URL_PARAM = 'bundle_id'

export const getBundleTrackingIdUrlParam = (urlQuery: string): string | null => {
  const param = toParams(urlQuery)[BUNDLE_TRACKING_ID_URL_PARAM]

  if (Array.isArray(param)) return null

  return param || null
}

export const removeBundleTrackingIdUrlParam = (relativeUrl: string, urlQuery: string) =>
  removeParamsFromQuery(relativeUrl, urlQuery, [BUNDLE_TRACKING_ID_URL_PARAM])

export const getIsBundlingAllowed = ({
  item,
  bundleItems,
  firstSelectedItemId,
}: {
  item: ProductItemModel
  bundleItems: Array<ProductItemModel>
  firstSelectedItemId?: number
}) => {
  if (!firstSelectedItemId) return true
  if (firstSelectedItemId === item.id) return true

  const bundleHasHeavyBulkyItem = bundleItems.find(
    bundleItem => bundleItem.id === firstSelectedItemId,
  )?.isHeavyBulky

  if (!bundleHasHeavyBulkyItem && item.isHeavyBulky) return false

  return !bundleHasHeavyBulkyItem
}
